import { render } from "./AdminHolidayListPage.vue?vue&type=template&id=1bd0a503"
import script from "./AdminHolidayListPage.vue?vue&type=script&lang=js"
export * from "./AdminHolidayListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__